import { z } from 'zod'

export const MagicLinkRequest = z.object({
  email: z.string().email(),
  /** Optional absolute return URL; the API validates it via safeNextUrl. */
  next: z.string().url().optional(),
})
export type MagicLinkRequest = z.infer<typeof MagicLinkRequest>

export const AuthUser = z.object({
  id: z.string(),
  email: z.string().email(),
  displayName: z.string().nullable(),
})
export type AuthUser = z.infer<typeof AuthUser>

export const Membership = z.object({
  registryId: z.string(),
  slug: z.string(),
  title: z.string(),
  role: z.enum(['owner']),
})
export type Membership = z.infer<typeof Membership>

export const AuthMeResponse = z.object({
  user: AuthUser,
  memberships: z.array(Membership),
})
export type AuthMeResponse = z.infer<typeof AuthMeResponse>
